<ul class="list-unstyled u-mb0 left-right-list left-right-list--online">
  <!-- ONLINE RESOURCES -->

  <li *ngIf="digitisationLink">
    <div class="left-right-list__entry qa-digitisation">
      <div i18n="@@libraryAvailability-label-digitalCopy">Digital copy</div>
      <div>
        <a
          class="btn btn-xs btn-default"
          [href]="relativeToBaseUri(digitisationLink)"
          (click)="trackDigitisationClick(digitisationLink)"
          target="_blank"
          rel="noopener"
          i18n="@@libraryAvailability-btn-viewOnline"
        >
          View online
        </a>
      </div>
    </div>
  </li>

  <!-- unavailable -->
  <li
    *ngIf="isUnavailableOnline() && isUnavailablePhysically()"
    class="left-right-list__entry qa-online-unavailable"
  >
    <div i18n="@@libraryAvailability-label-digitalCopies">Digital copies</div>
    <div>
      <a
        class="btn btn-xs btn-default disabled"
        i18n="@@libraryAvailability-btn-unavailable"
      >
        Unavailable
      </a>
    </div>
  </li>
  <!-- /unavailable -->

  <li *ngIf="resource?.allOnlineResources?.length ? true : false">
    <rl-digital-copy
      *ngFor="let onlineResource of resource.allOnlineResources"
      [onlineResource]="onlineResource"
      [resourceType]="resource.resource_type"
      (onlineResourceClick)="onlineResourceClick.emit($event)"
    >
    </rl-digital-copy>
  </li>

  <li *ngIf="resource?.part_of?.allOnlineResources?.length ? true : false">
    <rl-digital-copy
      *ngFor="let onlineResource of resource.part_of.allOnlineResources"
      [onlineResource]="onlineResource"
      [resourceType]="resource.part_of.resource_type"
      (onlineResourceClick)="onlineResourceClick.emit($event)"
    >
    </rl-digital-copy>
  </li>
</ul>
<!-- /ONLINE RESOURCES -->

<!-- LIBRARY HOLDINGS -->
<ul class="list-unstyled left-right-list left-right-list--library u-mb0">
  <!-- unavailable -->
  <li
    *ngIf="
      isUnavailableOnline() && isUnavailablePhysically() && !hasLibraryViewUrl()
    "
    class="left-right-list__entry"
  >
    <div i18n="@@libraryAvailability-label-physicalCopy">Physical copy</div>
    <div>
      <a
        class="btn btn-xs btn-default disabled"
        i18n="@@libraryAvailability-btn-unavailable"
      >
        Unavailable
      </a>
    </div>
  </li>
  <!-- /unavailable -->

  <!-- spinner -->
  <li
    *ngIf="physicalResources?.isLoading === true"
    class="left-right-list__entry"
  >
    <div i18n="@@libraryAvailability-status-checkingLibrary">
      Checking library
    </div>
    <div>
      <i class="far fa-spinner-third fa-fw fa-spin" aria-hidden="true"></i>
    </div>
  </li>
  <!-- /spinner -->

  <li
    *ngIf="
      !hasAlternativeCatalogueViewUrls() &&
      physicalResources?.isLoading !== true &&
      physicalResources?.data?.locations?.length > 0
    "
  >
    <div
      *ngFor="let location of physicalResources.data.locations"
      class="left-right-list__entry"
    >
      <div class="location">
        <span class="location__name">{{ location.location_name }}</span>
        <span *ngIf="location.shelf_mark" class="location__shelf-mark">{{
          location.shelf_mark
        }}</span>
      </div>
      <div class="location__availability-statement">
        <a
          [href]="relativeToBaseUri(physicalResources.data.library_view_url)"
          (click)="
            trackLibraryViewClick(physicalResources.data.library_view_url)
          "
          class="btn btn-xs btn-default qa-view-availability"
          target="_blank"
          rel="noopener"
        >
          <ng-container
            [ngSwitch]="location.availability_statement ? true : false"
          >
            <ng-container *ngSwitchCase="true">{{
              location.availability_statement
            }}</ng-container>
            <ng-container
              *ngSwitchDefault
              i18n="
                @@libraryAvailability-btn-checkAvailabilityPhysicalResources"
              >Check availability</ng-container
            >
          </ng-container>
        </a>
      </div>
    </div>
  </li>

  <li
    *ngIf="
      isUnavailablePhysically() &&
      hasLibraryViewUrl() &&
      !hasAlternativeCatalogueViewUrls()
    "
    class="left-right-list__entry"
  >
    <div i18n="@@libraryAvailability-label-library">Library</div>
    <div>
      <a
        [href]="relativeToBaseUri(physicalResources.data.library_view_url)"
        (click)="trackLibraryViewClick(physicalResources.data.library_view_url)"
        class="btn btn-xs btn-default qa-check-availability"
        target="_blank"
        rel="noopener"
        i18n="@@libraryAvailability-btn-checkAvailabilityUnavailablePhysically"
      >
        Check availability
      </a>
    </div>
  </li>

  <ng-container *ngIf="hasAlternativeCatalogueViewUrls()">
    <li
      *ngFor="let catalogue of physicalResources.data.catalogues"
      class="left-right-list__entry"
    >
      <ng-container *ngIf="catalogue.view_in_catalogue_url">
        <div i18n="@@libraryAvailability-label-libraryAlternativeCatalogue">
          Library: {{ catalogue.label }}
        </div>
        <div>
          <a
            [href]="relativeToBaseUri(catalogue.view_in_catalogue_url)"
            (click)="trackLibraryViewClick(catalogue.view_in_catalogue_url)"
            class="btn btn-xs btn-default qa-check-availability-alternative-catalogue"
            target="_blank"
            rel="noopener"
            i18n="
              @@libraryAvailability-btn-checkAvailabilityAlternativeCatalogue"
          >
            Check availability
          </a>
        </div>
      </ng-container>
    </li>
  </ng-container>

  <li *ngIf="item?.content">
    <rl-course-reserve-dates [item]="item"></rl-course-reserve-dates>
  </li>

  <li
    *ngIf="isRelevantForLibrarySearch()"
    class="left-right-list__entry left-right-list__entry--search"
  >
    <div>
      <a
        [href]="relativeToBaseUri(physicalResources.data.library_search_url)"
        (click)="
          trackLibrarySearchClick(physicalResources.data.library_search_url)
        "
        class="qa-view-other-formats"
        target="_blank"
        rel="noopener"
        i18n="@@libraryAvailability-link-otherFormats"
      >
        View other formats/editions
      </a>
    </div>
  </li>
</ul>
<!-- /LIBRARY HOLDINGS -->
